import {DynaCurrencies} from "dyna-currencies";

const currencies = new DynaCurrencies();

export {currencies};